// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"e89950bc","850":"053717f7"}[chunkId] + ".chunk.css";
};